export default "__VITE_ASSET__BQ$rKVl___"